// extracted by mini-css-extract-plugin
module.exports = {"slide-img":"ProductSilder_slide-img__1ZMAd"};